module.exports = __webpack_public_path__ + "img/NarminOsman-DwMaymwn.a9851573.jpg";